const LANG = 'language';

export const getLang = () => localStorage.getItem(LANG);
export const setLang = lang => localStorage.setItem(LANG, lang);
